/*
 * @Author: zhaohaozhuang
 * @Date: 2022-04-19 10:39:30
 * @LastEditors: liuxiaoyan
 * @LastEditTime: 2022-10-16 11:10:30
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */

export default {
  routes: [{
    path: '/grade/detail',
    name: 'grade_detail',
    component: () => import('@/module/grade/GradeDetail.vue'),
    meta: {
      title: '详情页',
      keepAlive: false,
      logined: false
    }
  },
  {
    path: '/grade/achievement',
    name: 'grade_achievement',
    component: () => import('@/module/grade/Achievement.vue'),
    meta: {
      title: '',
      keepAlive: false,
      logined: false
    }
  },
  {
    path: '/grade/empty',
    name: 'grade_empty',
    component: () => import('@/module/grade/GradeEmpty.vue'),
    meta: {
      title: '缺省页',
      keepAlive: false,
      logined: false
    }
  },
  {
    path: '/grade/apply',
    name: 'grade_apply',
    component: () => import('@/module/grade/GradeApply.vue'),
    meta: {
      title: '',
      keepAlive: true,
      logined: false
    }
  },
  {
    path: '/grade/apply_more',
    name: 'grade_apply_more',
    component: () => import('@/module/grade/GradeApplyMore.vue'),
    meta: {
      title: '',
      keepAlive: false,
      logined: false
    }
  },
  {
    path: '/grade/apply_detail',
    name: 'grade_apply_detail',
    component: () => import('@/module/grade/GradeApplyDetail.vue'),
    meta: {
      title: '报名详情页',
      keepAlive: false,
      logined: false
    }
  },
  {
    path: '/grade/pay',
    name: 'grade_pay',
    component: () => import('@/module/grade/GradePay.vue'),
    meta: {
      title: '付款',
      keepAlive: false,
      logined: false
    }
  },
  {
    path: '/grade/pay_success',
    name: 'grade_pay_success',
    component: () => import('@/module/grade/GradePaySuccess.vue'),
    meta: {
      title: '付款成功页',
      keepAlive: false,
      logined: false
    }
  }

  ]
}



// WEBPACK FOOTER //
// ./src/router/Grade.js